import React from "react";

export default function Intro(){
  return(
    <section id="intro-lifecycle">
      <a href="http://projects.wojtekmaj.pl/react-lifecycle-methods-diagram/"><h1>Diagramme des méthodes</h1><br /><p>http://projects.wojtekmaj.pl/react-lifecycle-methods-diagram/</p></a>
    </section>
  )
}